import React from "react";
import PropTypes from "prop-types";
import { MSpinner } from "components/Shared";
import { Grid, Cell } from "react-md";
import MCard from "components/Shared/MCard.tsx";
import { DATA_TYPE_BOOLEAN } from "typeConstants/dataTypes";
import MGrid, { FILTER_TYPE_NONE } from "components/Shared/MGrid.tsx";
import { DialogContext } from "components/Shared/DialogProvider.tsx";

class BrokerMaintenance extends React.Component {
	static contextType = DialogContext;

  static getDerivedStateFromProps(nextProps, prevProps) {
    if (nextProps.brokerSettings !== prevProps.brokerSettings && nextProps.brokerSettings.mortgageCompanyList) {
      return {
        brokerSettings: nextProps.brokerSettings,
        availableCompaniesObject: nextProps.brokerSettings.mortgageCompanyList.map(c => { return { key: c.id, value: c.id, label: c.name }; }),
        selectedCompaniesObject: nextProps.brokerSettings.mortgageCompanyList.filter((x) => { return x.selectedCompany == true; }).map(c => { return { key: c.id, value: c.id, label: c.name }; }), // { label: nextProps.selectedCompanies.isCorrespondent ? "Yes" : "No", value: nextProps.selectedCompanies.isCorrespondent} ,
        isCorrespondent: nextProps.brokerSettings.isCorrespondent,
        selectedCompanyIndex: nextProps.brokerSettings.mortgageCompanyList.filter((x) => { return x.selectedCompany == true; }).map(c => nextProps.brokerSettings.mortgageCompanyList.indexOf(c)),
      };
    }
    else return null;
  }

  constructor(props) {
    super(props);
    this.displayName = "BrokerSettings";
    this.handleBrokerIsCorrespondentSelectChange = this.handleBrokerIsCorrespondentSelectChange.bind(this);
    this.onCompanyEditFinished = this.onCompanyEditFinished.bind(this);
    this.onCompanyEditStarted = this.onCompanyEditStarted.bind(this);
    this.onCompanyEditCancelled = this.onCompanyEditCancelled.bind(this);
    this.getCompanyFields = this.getCompanyFields.bind(this);
    this.companyRowSelectionChanged = this.companyRowSelectionChanged.bind(this);
    this.saveCompanyUpdate = this.saveCompanyUpdate.bind(this);
    this.hideDialog = this.hideDialog.bind(this);

    //trigger a window resive to fix react data grid rendering issues
    for (let i = 0; i < 5; i++)setTimeout(() => window.dispatchEvent(new Event("resize")), i * 1000);

    this.state = {
      selectedCompaniesObject: [{ label: "", value: 0 }],
      availableCompaniesObject: [{ label: "", value: 0 }],
      isCorrespondent: false,
      isEditingCompanies: false,
      selectedCompanyIndex: [],
      originalIndex: []
    };
  }
  
  componentDidMount() {
    this.props.getBrokerSettings();
  }
  
  handleBrokerIsCorrespondentSelectChange(value) {
    this.props.saveBrokerCorrespondent({ isCorrespondent: value[0].value });
    this.setState({ isCorrespondent: value[0].value });
  }


  onCompanyEditStarted() {
    this.setState({ originalIndex: this.state.selectedCompanyIndex, isEditingCompanies: true });
  }

  saveCompanyUpdate() {
    this.props.saveBrokerCompanies({
      selectedCompanies: this.state.SavedSelected.map((c) => { return this.state.availableCompaniesObject[c].value; }),
    });
  }

  companyRowSelectionChanged(selected) {
    this.setState({ selectedCompanyIndex: selected });
  }

  onCompanyEditCancelled() {
    this.setState({ selectedCompanyIndex: this.state.originalIndex, isEditingCompanies: false });
  }

  onCompanyEditFinished() {
    this.setState({ SavedSelected: this.state.selectedCompanyIndex });
    let dialogMessage = "Click confirm to save your changes (once confirmed you will be logged out)";
    let dialogYesClick = this.saveCompanyUpdate;
    let dialogNoClick = this.hideDialog;
    let dialogYesLabel = "Confirm";
    let dialogNoLabel = "Cancel";
    this.context.showYesNo(null, dialogMessage, dialogYesClick, dialogNoClick, dialogYesLabel, dialogNoLabel);
  }

  hideDialog() {
    this.setState({ selectedCompanyIndex: this.state.originalIndex, isEditingCompanies: false });
  }

  getCompanyFields() {
    if (!this.state.selectedCompaniesObject) return [];

    let colDefs = [
      { key: "companies", name: "Companies", dataSource: "label" },
    ];

    let companies;

    if (this.state.isEditingCompanies) {
      companies = this.state.availableCompaniesObject;
      colDefs.forEach(cd => cd.filterType = FILTER_TYPE_NONE);
    } else {
      companies = this.state.selectedCompaniesObject;
      colDefs.forEach(cd => cd.filterType = FILTER_TYPE_NONE);
    }

    return [{
      key: "grid", control: (
        <MGrid
          columnDefinitions={colDefs}
          data={companies}
          dataLastChanged={this.state.lastCompanyGridDataUpdate}
          {... this.state.isEditingCompanies && {
            allowRowSelection: true,
            onRowSelectionChanged: this.companyRowSelectionChanged,
            selectedRows: this.state.selectedCompanyIndex// this.state.selectedCompaniesObject
          }}
        />)
    }];
  }

  render() {
    const {
      isFetchingSettings,
      isSubmittingSettings,
    } = this.props;

    if (isFetchingSettings || isSubmittingSettings) {
      return <MSpinner />;
    }

    return (
      <Grid>
        <Cell size={4}>
          <MCard title="General" fields={[
            { key: "brokerIsCorrespondent", label: "Correspondent Lender", value: this.state.isCorrespondent, dataType: DATA_TYPE_BOOLEAN },
          ]} isEditable={true} onEditFinished={this.handleBrokerIsCorrespondentSelectChange} />
        </Cell>
        <Cell size={4}>
          <MCard
            className="appraiserCountyProficiency hideGridHorizontalScroll"
            title="Available Companies"
            fields={this.getCompanyFields()}
            isEditable={true}//{!!this.state.appraiserCounties} //dont let the user be able to press the edit button if we dont have any data loaded yet
            singleColumn
            onEditStarted={this.onCompanyEditStarted}
            onEditCancelled={this.onCompanyEditCancelled}
            onEditFinished={this.onCompanyEditFinished}
          />
        </Cell>
      </Grid>
    );
  }
}

BrokerMaintenance.propTypes = {
  isFetchingSettings: PropTypes.bool.isRequired,
  isSubmittingSettings: PropTypes.bool.isRequired,
  brokerSettings: PropTypes.object.isRequired,
  getBrokerSettings: PropTypes.func.isRequired,
  saveBrokerCorrespondent: PropTypes.func.isRequired,
  saveBrokerCompanies: PropTypes.func.isRequired,
};

export default BrokerMaintenance;
